import React from 'react';
import { Fragment, useEffect } from 'react';
import { useTranslation } from 'react-i18next/hooks';

import { useStore } from '../../hook-store/store';
import { updateGroupUserEmail } from '../../util/group/group-user';
import { getUserGroupInvitation } from '../../util/group/group-invitation';
import { 
  getUserData, 
  getUserDataForStore, 
  getUsers, 
  getUsersRest, 
  getUsersForGroup, 
  getUserLocation, 
  updateUserColor 
} from '../../util/user';
import { getRandomBgColor } from '../../util/color-style';

import { 
  SOCKET_GROUP_URL, 
  BASE_URL, 
} from '../../App';

const GroupUserUpdate = (props) => {
  const {
    userId,
    setNoUserMessage,
  } = props;

  const [t] = useTranslation('translation');

  const [store, dispatch] = useStore();
  const { 
    isAuth,
  } = store.uiStore;
  const { 
    userData, 
  } = store;

    useEffect(() => {
      if (userId && !userId.startsWith('na-')) {
        getUserLocation()
          .then(res => {
            console.log(res);
          })
          .catch(err => {
            console.log(err);
          });
      }
    },[userId]);
  
    useEffect(() => {
  
      if (!userId) {
        if (!store.userData) {
          // getUserData(GQL_URL, localStorage.getItem('token'))
          getUserDataForStore(BASE_URL, localStorage.getItem('token'))
          .then(result => {
            console.log(result);
  
            dispatch('SET_USERDATA', result.userData);
  
            // setUserName(result.userData.name);
    
            // setUserId(result.userData.data.user._id);
            // setUserId(result.userData.userId);
    
            // if (result.userData.imageUrl) {
            //   setUserImageUrl(result.userData.imageUrl);
            // }
  
            if (!result.userData.userColor) {
              updateUserColor(
                BASE_URL,
                localStorage.getItem('token'),
                result.userData.userId,
                getRandomBgColor(),
              );
            }
            // socketConnectHandler();
          })
          .catch(err => {
            console.log('getUserDataForStore err', err);
            // setNoUserMessage('need to login');
            setNoUserMessage('');
  
            //// if user data not found (not login), set non-auth userId and name
            const noAuthUserId = `na-${Math.floor(Date.now()/100).toString()}`;
            // setUserId(noAuthUserId);
            dispatch('SET_GROUPNOAUTHUSERID', noAuthUserId);
  
            // setUserName('na');
          });
        }
  
        if (isAuth && userData) {
          // setUserName(store.userData.name);
          // setUserId(store.userData._id);
          // setUserId(store.userData.userId);
  
          // if (store.userData.imageUrl) {
          //   setUserImageUrl(store.userData.imageUrl);
          // }
  
          if (!store.userData.userColor) {
            updateUserColor(
              BASE_URL,
              localStorage.getItem('token'),
              store.userData.userId,
              getRandomBgColor(),
            );
          }
        }
      } 
    }, [userId]);


  useEffect(() => {
    if (isAuth) {
      updateGroupUserEmail(
        SOCKET_GROUP_URL,
        localStorage.getItem('token'),
      );
      
      getGroupInvitationHandler();
    }
  },[isAuth]);


  const getGroupInvitationHandler = async () => {
    try {
      const resData = await getUserGroupInvitation(
        SOCKET_GROUP_URL,
        localStorage.getItem('token'),
      );

      if (resData.data) {
        dispatch('SET_USERGROUPINVITATION', resData.data);
      }

    } catch(err) {
      console.log(err);
      throw err;
    }
  }

  return (
    <Fragment></Fragment>
  );
}

export default GroupUserUpdate;